export enum EntityType {
  UserRoleAuxList = 'userrole_aux_list',
  RoleAuxList = 'role_aux_list',
  ChannelAuxList = 'channel_aux_list',
  UsersAuxList = 'users_aux_list',
  HotelAuxList = 'hotel_aux_list',
  RoomAuxList = 'room_aux_list',
  RoomTypeAuxList = 'roomtype_aux_list',
  RoomtypecapacityAuxList = 'roomtypecapacity_aux_list',
  BillingEntityAuxList = 'billingentity_aux_list',
  EnvironmentDataAuxList = 'environment_data_aux_list',
  ZoneAuxList = 'zone_aux_list',
  UserEnvironmentDataAuxList = 'userenvironmentdata_aux_list',
  UserEnvironmentDataViewAuxList = 'userenvironmentdataview_aux_list',
  UserChannelAuxList = 'userchannel_aux_list',
  UserRoomTypeAuxList = 'userroomtype_aux_list',
  UserZoneAuxList = 'userzone_aux_list',
  UserHotelAuxList = 'userhotel_aux_list',
  UserRoomAuxList = 'userroom_aux_list',
  UserBillingEntityAuxList = 'userbillingentity_aux_list',
  ReportAuxList = 'report_aux_list',
  OfferAuxList = 'offer_aux_list',
  OfferChannelAuxList = 'offerchannel_aux_list',
  OfferRateAuxList = 'offerrate_aux_list',
  OfferRoomAuxList = 'offerroom_aux_list',
  OfferRoomTypeAuxList = 'offerroomtype_aux_list',
  VatTypeAuxList = 'vattype_aux_list',
  OfferRateList = 'offerrate_aux_list'
}

export enum EntityState {
  Saved = 'G' /* Guardado */,
  Modified = 'M' /* Modificado */,
  Deleted = 'B' /* Borrado */,
  New = 'N' /* Nuevo */
}

export interface List {
  id: string
  name: string
  selected: boolean
  value: string
}
